module.exports = "<div id=\"slider\" class=\"c-slider-input\">\n\t<span id=\"value\" class=\"c-slider-input__value\">0</span>\n\t<span class=\"c-slider-input__start-value\">0</span>\n\t<span class=\"c-slider-input__end-value\">100</span>\n\t<span class=\"c-slider-input__label\">ETİKET</span>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/common-module/components/slider-input/slider-input.component.html
// module id = ./src/app/modules/common-module/components/slider-input/slider-input.component.html
// module chunks = 9